<template>
  <div>
    <div class="panel panel--minimal-pad">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-m">
          <div class="search-form width-100">
            <span class="search hidden--xs">
              <span class="search__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>
                  </svg>
              </span>
              <span class="search__input">
                  <input type="text" class="form__input" placeholder="Search transfers">
              </span>
            </span>
          </div>
        </div>
        <div class="panel__header__right">
          <div class="filter__options">
            <button class="btn btn--default btn--flex">
            <span class="btn__icon">
              <svg class="" enable-background="new 0 0 971.986 971.986" version="1.1" viewBox="0 0 971.986 971.986" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#576ae6" d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z" />
              </svg>
            </span>
              <span class="btn__text">Add filter</span>
            </button>
          </div>
          <div class="select filter__date">
            <select name="disburse-source" id="disburseSource" class="select__input select__input--sm">
              <option value="Bank source">Today</option>
              <option value="Card source">Yesterday</option>
            </select>
            <div class="select__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
            </div>
          </div>
        </div>
      
      </div>
      <div class="panel__content panel__content--grey outer-container">
        <div class="table__section table__section--head">
          Showing <span>all recurring transfers</span>
        </div>
        <!--funding history table-->
        <div class="table">
          <!-- Table body -->
          <div class="table__section table__section--body">
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Weekly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
                  
                  <span>Thursday</span>

                </div>
              </div>
              
              
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Thurs, Oct 23</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
              
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
            
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Monthly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>25th</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Fri, Nov 25</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
            
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Yearly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>January 23rd</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Mon, Jan 23</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
            
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Weekly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>Thursday</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Thurs, Oct 23</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
  
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Weekly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>Thursday</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Thurs, Oct 23</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
  
            <div class="table__row spacer"></div>
  
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Monthly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>25th</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Fri, Nov 25</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
  
            <div class="table__row spacer"></div>
  
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Yearly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>January 23rd</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Mon, Jan 23</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
  
            <div class="table__row spacer"></div>
  
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Weekly</div>
                <div class="table__data--sub">
                  <svg class="icon--xxs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.996 511.996" style="enable-background:new 0 0 511.996 511.996;" xml:space="preserve">
                    <path d="M255.865,469.419c-82.056,0.005-160.43-47.572-195.569-127.357c-2.675-6.071,0.08-13.159,6.15-15.834
                      c6.073-2.673,13.161,0.081,15.834,6.151c31.181,70.796,100.739,113.015,173.551,113.018c25.454,0.001,51.3-5.157,76.049-16.058
                      c65.08-28.665,107.961-91.105,112.648-160.573l-23.481,23.15c-4.722,4.658-12.326,4.604-16.987-0.12
                      c-4.656-4.725-4.603-12.329,0.121-16.987l43.685-43.072c1.882-1.876,4.394-3.142,7.227-3.437c0.191-0.02,0.38-0.035,0.571-0.045
                      c0.009,0,0.016,0,0.023-0.001c3.616-0.204,6.995,1.241,9.342,3.696l43.573,44.863c4.622,4.759,4.511,12.364-0.248,16.986
                      c-4.759,4.622-12.364,4.511-16.986-0.248l-22.849-23.525c-5.16,78.427-53.514,148.951-126.958,181.301
                      C313.679,463.604,284.542,469.417,255.865,469.419z M54.772,284.063c-2.815,0-5.436-0.984-7.506-2.645c-0.001,0-0.001,0-0.001,0
                      c-0.009-0.007-0.017-0.013-0.025-0.02c-0.003-0.001-0.005-0.004-0.008-0.005c-0.005-0.004-0.012-0.009-0.017-0.015
                      c-0.004-0.003-0.009-0.007-0.013-0.011s-0.008-0.007-0.012-0.009c-0.005-0.004-0.012-0.009-0.017-0.013
                      c-0.003-0.001-0.005-0.004-0.008-0.007c-0.007-0.005-0.015-0.011-0.021-0.017l0,0c-0.061-0.051-0.123-0.103-0.184-0.155l0,0
                      c-0.008-0.007-0.016-0.013-0.024-0.02c-0.001-0.001-0.003-0.003-0.004-0.003c-0.007-0.005-0.013-0.012-0.021-0.017
                      c-0.001-0.003-0.005-0.005-0.008-0.007c-0.005-0.005-0.011-0.009-0.017-0.015c-0.004-0.003-0.008-0.007-0.012-0.009
                      c-0.004-0.004-0.008-0.008-0.013-0.012c-0.005-0.005-0.012-0.011-0.019-0.016c-0.001-0.003-0.004-0.004-0.007-0.007
                      c-0.276-0.244-0.541-0.5-0.794-0.767L3.343,235.77c-4.591-4.787-4.434-12.392,0.355-16.983c4.787-4.591,12.391-4.434,16.983,0.354
                      l21.922,22.855c5.188-78.39,53.519-148.856,126.953-181.202c52.157-22.971,110.138-24.259,163.265-3.622
                      c53.124,20.636,95.033,60.726,118.003,112.884c2.675,6.071-0.08,13.161-6.15,15.834c-6.072,2.673-13.162-0.081-15.834-6.151
                      c-20.384-46.284-57.574-81.86-104.717-100.174c-47.141-18.312-98.595-17.173-144.883,3.215
                      c-65.34,28.78-108.287,91.573-112.702,161.356l24.532-23.532c4.79-4.591,12.392-4.434,16.984,0.354
                      c4.592,4.787,4.434,12.391-0.354,16.983l-44.532,42.713c-1.879,1.835-4.368,3.064-7.172,3.347c-0.155,0.016-0.31,0.028-0.466,0.039
                      c-0.008,0-0.017,0.001-0.027,0.001C55.258,284.057,55.015,284.063,54.772,284.063z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
        
                  <span>Thursday</span>
      
                </div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Thurs, Oct 23</div>
                <div class="table__data--sub">Next transfer</div>
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
  
            <div class="table__row spacer"></div>
          
          </div>
        </div>
      </div>
    </div>
    <pagination></pagination>
  </div>

</template>

<script>
  import PaginationView from '@/components/partials/PaginationView'
  
  export default {
    
    data() {
      return {
      }
    },
    components:{
      'pagination': PaginationView
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/transfers/RecurringTransfers.vue